import * as React from 'react';
import { Input } from '@/components/ui/input';
import { usePermissions, Permission } from '@/hooks/use-permissions';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface PermissionInputProps extends React.ComponentProps<"input"> {
  permission: Permission | Permission[];
  fallbackText?: string;
}

export function PermissionInput({ 
  permission, 
  fallbackText, 
  disabled,
  ...props 
}: PermissionInputProps) {
  const { hasPermission, hasAnyPermission } = usePermissions();
  
  const hasRequiredPermission = Array.isArray(permission) 
    ? hasAnyPermission(permission)
    : hasPermission(permission);
  
  const isDisabled = disabled || !hasRequiredPermission;
  
  if (!hasRequiredPermission && fallbackText) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div>
              <Input {...props} disabled={true} />
            </div>
          </TooltipTrigger>
          <TooltipContent>
            <p>{fallbackText}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }
  
  return (
    <Input {...props} disabled={isDisabled} />
  );
}
